// TODO: can we have id?: Nullable<string>
export const isEntityId = (id: string, type?: string) => {
  let isId = false;

  // TODO: with id:string this check is nonsense
  if (typeof id === 'string') {
    const [entityType, objectId] = id.split(':');

    if (
      ((type && type === entityType) || !type) &&
      objectId &&
      objectId.length === 24
    ) {
      isId = true;
    }
  }

  return isId;
};
